import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * A custom hook for managing URL query parameters.
 */
function useURLParams() {
    const location = useLocation();
    const navigate = useNavigate();
    const [urlParams, setURLParams] = useState<URLSearchParams>(
        new URLSearchParams(location.search),
    );

    useEffect(() => {
        setURLParams(new URLSearchParams(location.search));
    }, [location.search]);

    const setParam = (key: string, value: string | null) => {
        const newParams = new URLSearchParams(urlParams.toString());

        if (value === null) {
            newParams.delete(key);
        } else {
            newParams.set(key, value);
        }

        // Maintain the current pathname while updating search params
        navigate(
            {
                pathname: location.pathname,
                search: newParams.toString(),
            },
            { replace: true },
        );
    };

    const getParam = (key: string): string | null => {
        return urlParams.get(key);
    };

    return { urlParams, setParam, getParam };
}

export default useURLParams;
